var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 218,
    viewBox: "0 0 218 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 109,
    r: 109,
    fill: "#EBFAFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.443,
    cy: 108.556,
    r: 83.7439,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.187 104.828L105.295 125.936L139.069 92.1631",
    stroke: "#FFFFFE",
    strokeWidth: 3.54472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDone);
export default __webpack_public_path__ + "static/media/survey-done.2b595e0163ff2a83e23bbebc64301c57.svg";
export { ForwardRef as ReactComponent };